// eslint-disable-next-line import/prefer-default-export
export const DIMENSIONS_MESSAGE_ERROR =
  'El paquete supera el peso o las dimensiones máximas permitidas'

export const STATUS_COMPLETED_ID = 4
export const STATUS_CANCELED_ID = 5

export const STATUS_COMPLETED_NAME = 'Completado'
export const STATUS_READY_TO_SHIP_NAME = 'Listo para enviar'
export const STATUS_TEMPORARY_CANCELLATION_NAME = 'Cancelación Temporal'
export const DIGITAL_CONTENT_PENDING_NAME = 'Pendiente contenido digital'
export const STATUS_CANCELED_NAME = 'Cancelado'

export const MANUAL_GUIDE_ELIGIBLE_STATUSES = [
  STATUS_READY_TO_SHIP_NAME,
  STATUS_TEMPORARY_CANCELLATION_NAME,
]

const STATUSES = [
  { id: STATUS_COMPLETED_ID, name: STATUS_COMPLETED_NAME },
  { id: STATUS_CANCELED_ID, name: STATUS_CANCELED_NAME },
]

export const STATUS_DICTIONARY = Object.fromEntries(
  STATUSES.map((status) => [
    status.name,
    {
      ...status,
      options: STATUSES.filter((s) => s.id !== status.id),
    },
  ])
)

export const getStatusOptions = (statusName) => {
  return STATUS_DICTIONARY[statusName]?.options || []
}

export const ORDER_STATUS_ADMIN_LIST = [STATUS_COMPLETED_NAME, STATUS_CANCELED_NAME]
